import { CookieFunction } from '../../types/CookieFunction.types.js';

import cookie from '../../util/cookie.js';
import { closeDialog } from '../../util/dialog_helpers.js';

export const COOKIE_ID_SAW_KOREAN_BROWSE_FONTS_DIALOG = 'adobe-fonts-saw-korean-browse-fonts-dialog';

export function attachEventHandlers(dialog: HTMLElement) {
  const okButton = dialog.querySelector('.korean-browse-fonts-button');
  if (okButton) {
    okButton.addEventListener('click', handleOkButtonClick, { once: true });
  }
}

async function handleOkButtonClick() {
  const checkBox = document.querySelector<HTMLInputElement>('[data-id="korean-browse-fonts-checkbox"]');
  if (checkBox?.checked) {
    (cookie as unknown as CookieFunction)(COOKIE_ID_SAW_KOREAN_BROWSE_FONTS_DIALOG, true, {
      expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1))
    });
  }

  closeDialog();
};
